import { Button, Icon, PopoverMenu } from '@yembo/yemblocks-core';
import { useState } from 'react';
import { Room } from 'src/types';

type Props = {
  imageUrl: string;
  rooms: Room[];
  jobImageToRoom: (imageUrl: string, room: Room) => Promise<void>;
  buttonText?: string;
};

type ReturnType = {
  roomsMenu: React.JSX.Element | null;
  isMovingToRoom: boolean;
  isRoomsMenuOpen: boolean;
};

export const useJobImageToRoomMenu = ({ imageUrl, rooms, jobImageToRoom, buttonText }: Props): ReturnType => {
  const [isMovingToRoom, setIsMovingToRoom] = useState(false);
  const [isRoomsMenuOpen, setIsRoomsMenuOpen] = useState(false);

  const menuOptions = rooms.map((room) => {
    return {
      name: room.name,
      onClick: async () => {
        setIsMovingToRoom(true);
        try {
          await jobImageToRoom(imageUrl, room);
        } finally {
          setIsMovingToRoom(false);
        }
      },
    };
  });

  const roomsMenu = rooms.length ? (
    <PopoverMenu
      menuOptions={menuOptions}
      onOpenCallback={() => setIsRoomsMenuOpen(true)}
      onCloseCallback={() => setIsRoomsMenuOpen(false)}
      menuClassName='rooms-list-menu'
      menuPlacement='right-start'
      clickableElement={
        <Button kind='flat' text={buttonText} isLoading={isMovingToRoom} icon={<Icon name='arrow-right' />} />
      }
    />
  ) : null;

  return { roomsMenu, isMovingToRoom, isRoomsMenuOpen };
};
